import Vue from 'vue'
import UiIcon from '@/components/ui/UiIcons/UiIcons.vue'

export interface IconPropItem extends Readonly<{
  iconName: string
  fill?: string
  stroke?: string
  width: string
  height: string
  originalColor?: boolean
}> {}

export interface IconProps extends Readonly<{
  [key: string]: IconPropItem
}> {}

export const iconsList: IconProps = {
  logo: {
    iconName: 'logo',
    originalColor: true,
    width: '143px',
    height: '40px'
  },
  logoMobile: {
    iconName: 'logo-mobile',
    originalColor: true,
    width: '36px',
    height: '19px'
  },
  youtubeIcon: {
    iconName: 'youtubeIcon',
    fill: '--main-violet',
    width: '23px',
    height: '16px'
  },
  fbIcon: {
    iconName: 'fbIcon',
    fill: '--main-violet',
    width: '13px',
    height: '22px'
  },
  instIcon: {
    iconName: 'instIcon',
    fill: '--main-violet',
    width: '20px',
    height: '20px'
  },
  vkIcon: {
    iconName: 'vkIcon',
    fill: '--main-violet',
    width: '24px',
    height: '14px'
  },
  locationIcon: {
    iconName: 'locationMark',
    originalColor: true,
    width: '14px',
    height: '14px'
  },
  leftArrow: {
    iconName: 'arrow-left',
    originalColor: true,
    width: '9px',
    height: '11px'
  },
  rightArrow: {
    iconName: 'arrow-right',
    originalColor: true,
    width: '10px',
    height: '11px'
  },
  favouriteIcon: {
    iconName: 'favouriteIcon',
    originalColor: true,
    width: '22px',
    height: '18px'
  },
  unfavouriteIcon: {
    iconName: 'favouriteIcon',
    fill: '--additional-light-gray',
    width: '22px',
    height: '18px'
  },
  lockerIcon: {
    iconName: 'locker',
    originalColor: true,
    width: '10px',
    height: '13px'
  },
  documentsIcon: {
    iconName: 'documentsIcon',
    originalColor: true,
    width: '60px',
    height: '37px'
  },
  backArrow: {
    iconName: 'back-arrow',
    originalColor: true,
    width: '6px',
    height: '10px'
  },
  balloon: {
    iconName: 'balloon',
    originalColor: true,
    width: '9px',
    height: '12px'
  },
  favouriteMenuIcon: {
    iconName: 'favourite-menu',
    originalColor: true,
    width: '28px',
    height: '21px'
  },
  unfavouriteMenuIcon: {
    iconName: 'unfavourite-menu',
    originalColor: true,
    width: '28px',
    height: '21px'
  },
  webIcon: {
    iconName: 'webIcon',
    originalColor: true,
    width: '13px',
    height: '13px'
  },
  webIconSmall: {
    iconName: 'webIcon',
    originalColor: true,
    width: '11px',
    height: '11px'
  },
  fullscreenIcon: {
    iconName: 'fullscreenIcon',
    originalColor: true,
    width: '20px',
    height: '20px'
  },
  fullscreenBig: {
    iconName: 'fullscreenIcon',
    originalColor: true,
    width: '28px',
    height: '28px'
  },
  installment: {
    iconName: 'installment',
    originalColor: true,
    width: '47px',
    height: '47px'
  },
  mortgage: {
    iconName: 'mortgage',
    originalColor: true,
    width: '47px',
    height: '47px'
  },
  oneTimePayment: {
    iconName: 'oneTimePayment',
    originalColor: true,
    width: '47px',
    height: '47px'
  },
  tradeIn: {
    iconName: 'tradeIn',
    originalColor: true,
    width: '47px',
    height: '47px'
  },
  shareHolders: {
    iconName: 'shareHolders',
    originalColor: true,
    width: '47px',
    height: '47px'
  },
  single: {
    iconName: 'single',
    originalColor: true,
    width: '47px',
    height: '47px'
  },
  spouses: {
    iconName: 'spouses',
    originalColor: true,
    width: '47px',
    height: '47px'
  },
  withChildren: {
    iconName: 'withChildren',
    originalColor: true,
    width: '47px',
    height: '47px'
  }
}

export const iconsMixin = Vue.extend({
  data () {
    return {
      iconsList
    }
  },
  components: {
    UiIcon
  }
})
